/**
 * Created by robert.lavoie on 4/17/17.
 */

import { SiteColumn, Image } from './';

export const SECTION_TYPE_CONTENT = 'content';
export const SECTION_TYPE_JOB_SEARCH = 'job-search';

export enum SectionType {
  CONTENT = 'content',
  JOB_SEARCH = 'job-search',
}

export interface SiteSection {
  isReadOnly: boolean;
  header?: SiteColumn;
  backgroundImage?: Image;
  backgroundColor?: string;
  columns: SiteColumn[];
  type?: string;
  fullWidth?: boolean;
};

export function getJobSearchSection(): SiteSection {
  return {
    isReadOnly: false,
    type: SectionType.JOB_SEARCH,
    columns: [],
  }
}

export function getCompanyOverviewSection(): SiteSection {
  return {
    isReadOnly: false,
    type: SectionType.CONTENT,
    columns: [
      {
        type:'text',
        html:'<h3><span style="color: rgb(0, 130, 194);">Company Overview</span></h3><p>The Good Company is based in Charleston, South Carolina and we’re on a mission to bring you the best every day. We were founded on the principles of high quality products and great customer service. We believe you can have fun and still make a difference. Its what we built our culture around and why we’re so great at what we do.</p>'
      },
      {
        type:'image',
        image:{ url: '/assets/images/the-good-company/tgc-company-overview.png' }
      }
    ]
  }
};

export function getCompanyBenefitsSection(): SiteSection {
  return {
    isReadOnly: false,
    type: SectionType.CONTENT,
    columns: [
      {
        type:'text',
        html:'<h3><span style="color: rgb(0, 130, 194);">Company Benefits</span></h3><p>The good company offers a wide variety of employee benefits raging from: Health Care Insurance, Disability Insurance, Life Insurance, Retirement / Pension Plans, Flexible Compensation, and Paid Leave.</p><p>We are also family focused so we work with you to provide you with a schedule that brings the best out of your character at work and at home.</p>'
      },
      {
        type:'image',
        image:{ url: '/assets/images/the-good-company/tgc-company-benefits.png' }
      }
    ]
  }
};

export function getCompanyCultureSection(): SiteSection {
  return {
    isReadOnly: false,
    type: SectionType.CONTENT,
    columns: [
      {
        type:'text',
        html:'<h3><span style="color: rgb(0, 130, 194);">Company Culture</span></h3><p>The Good Company is filled with energetic, creative, positive, hardworking, team members who bring out the best in each other day in and day out. We have fun, we work hard, and we celebrate each other’s successes. If that sounds like you or someone you know, click the link below… we’re always looking for the best of the best!</p>'
      },
      {
        type:'image',
        image:{ url: '/assets/images/the-good-company/tgc-company-culture.png' }
      }
    ]
  }
};

export function getCallToActionSection(): SiteSection {
  return {
    isReadOnly: false,
    type: SectionType.CONTENT,
    fullWidth: true,
    columns: [
      {
        type:'cta',
        backgroundImage: {url: '/assets/images/the-good-company/server-female@2x.png' },
        html: ''
      },
      {
        type:'cta',
        backgroundImage: {url: '/assets/images/the-good-company/boards@2x.png' },
        html:'<h3 class="ql-align-center"><span style="color: rgb(255, 255, 255);" data-override="true">Get a job that fits your life, inspires your best and moves you forward.</span></h3>',
        buttonLink: {
          text: 'Learn More',
          url: 'http://snag.co'
        }
      },
      {
        type:'cta',
        backgroundImage: {url: '/assets/images/the-good-company/server-male@2x.png' },
        html: ''
      }
    ]
  }
};

export function getTeamBiosSection(): SiteSection {
  return {
    isReadOnly: false,
    type: SectionType.CONTENT,
    header: {
      type:'text',
      html:'<h3 class="ql-align-center"><span style="color: rgb(0, 130, 194);">Team Bios</span></h3>'
    },
    columns: [
      {
        type:'text',
        image: { url: '/assets/images/the-good-company/tgc-employee1.png' },
        html:'<h3 class="ql-align-center"><span style="color: rgb(0, 130, 194);">Colin Achiova</span></h3><p>You are passionate, articulate & knowledgeable about food & drink and you bring previous experience. You are contagiously friendly with a professional polish that we enhance with dedicated training to enable you to be the best you can be and earn an exceptional income.</p>'
      },
      {
        type:'text',
        image: { url: '/assets/images/the-good-company/tgc-employee2.png' },
        html:'<h3 class="ql-align-center"><span style="color: rgb(0, 130, 194);">Katy Inogri</span></h3><p>You are passionate, articulate & knowledgeable about food & drink and you bring previous experience. You are contagiously friendly with a professional polish that we enhance with dedicated training to enable you to be the best you can be and earn an exceptional income.</p>'

      },
      {
        type:'text',
        image: { url: '/assets/images/the-good-company/tgc-employee3.png' },
        html:'<h3 class="ql-align-center"><span style="color: rgb(0, 130, 194);">Jessica Suthers</span></h3><p>You are passionate, articulate & knowledgeable about food & drink and you bring previous experience. You are contagiously friendly with a professional polish that we enhance with dedicated training to enable you to be the best you can be and earn an exceptional income.</p>'
      }
    ]
  }
};
